import classNames from 'classnames'

import Fixture from '~/components/atoms/Fixture/Fixture'

import Container from '../Container/Container'
import Text, { TextSizes } from '../Text/Text'

import styles from './TextStatsBlock.module.css'

export interface TextStatsBlockProps {
  stats: {
    stat: string
    text: string
  }[]
  title?: string
  verticalPadding?: boolean
  largePaddingBottom?: boolean
  noPaddingBottom?: boolean
  borderBottom?: boolean
  testID?: string
  moduleId?: string
}

export default function TextStatsBlock({
  stats,
  title,
  verticalPadding,
  noPaddingBottom,
  largePaddingBottom,
  testID,
  borderBottom = true,
  moduleId,
}: TextStatsBlockProps) {
  return (
    <Fixture
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <Container>
        <div
          className={classNames(
            styles.base,
            largePaddingBottom && styles.largePaddingBottom,
            borderBottom && styles.borderBottom
          )}
        >
          {title && (
            <Text
              Tag="p"
              size={TextSizes.primaryTitleLrg}
              className={styles.title}
            >
              {title}
            </Text>
          )}
          <div className={styles.statsWrap} data-testid={testID}>
            {stats?.map((item, i) => {
              return (
                <div key={i} className={styles.statItem}>
                  <Text
                    size={TextSizes.secondaryTitleLrg}
                    className={styles.stat}
                  >
                    <span dangerouslySetInnerHTML={{ __html: item.stat }} />
                  </Text>
                  <Text
                    size={TextSizes.bodyMed}
                    className={styles.statText}
                    uppercase
                  >
                    <span dangerouslySetInnerHTML={{ __html: item.text }} />
                  </Text>
                </div>
              )
            })}
          </div>
        </div>
      </Container>
    </Fixture>
  )
}
